import { FormProvider } from '@slal/ui/react-hook-form/core';
import { Field, FieldSet, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { Article, Heading, P } from '@slal/ui/typography';
import { MaxWidthContent, StyledForm, yesOrNoOptions } from '~/components';
import { ApplicationButtons } from '~/features';
import { useKeyConsiderationsApplicationForm } from './hooks';
import { SelectedYesNoContent } from './SelectedYesNoContent';

const YesContent = () => {
    return (
        <Article>
            <Heading level={5}>
                That's important. Make sure you let us know who you would like your remaining pension pot to go to when
                you pass away.
            </Heading>
            <P>When you die this can normally go to the people or causes you care about inheritance tax-free.</P>
            <P>
                Nominate the people you would like us to pay the remaining money to. You can do this online. It's
                confidential and if you change your mind simply let us know.
            </P>
        </Article>
    );
};

const NoContent = () => {
    return (
        <Article>
            <Heading level={5}>Thanks, that makes things easier.</Heading>
            <P>
                It's still important to let us know the people or causes you want to leave your money to when you die.
            </P>
            <P>If your circumstances change in the future, you can always change or add new beneficiaries online.</P>
        </Article>
    );
};

export const RemainingPensionForm = () => {
    const { form, handleSubmit, name, option } = useKeyConsiderationsApplicationForm(
        'remainingPension',
        '/application/bank-details'
    );

    return (
        <MaxWidthContent>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit}>
                    <FieldSet aria-label="Remaining pension">
                        <Field errorFor={name}>
                            <RadioFieldGroup name={name} options={yesOrNoOptions} stacked />
                        </Field>
                    </FieldSet>
                    {option && (
                        <SelectedYesNoContent option={option} YesContent={<YesContent />} NoContent={<NoContent />} />
                    )}
                    <ApplicationButtons backTo="/application/key-considerations/still-invested" />
                </StyledForm>
            </FormProvider>
        </MaxWidthContent>
    );
};
